import { render } from "./ChatIconSend.vue?vue&type=template&id=da89fc2c&scoped=true"
import script from "./ChatIconSend.vue?vue&type=script&lang=js"
export * from "./ChatIconSend.vue?vue&type=script&lang=js"

import "./ChatIconSend.vue?vue&type=style&index=0&id=da89fc2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da89fc2c"]])

export default __exports__